import type { CctpSdkContext, CctpTransactionsArgs } from '@/types/sdk/experimental/cctp/cctpTypes'
import type { CctpTransactionsResponse } from '@vaultsfyi/common/schemas'
import { parseCctpError } from './parseCctpError'

export const getCctpTransactions = async (
  ctx: CctpSdkContext,
  {
    action,
    userAddress,
    srcNetwork,
    dstNetwork,
    amount,
    useForwarding,
    transferType,
    recipientAddress,
    message,
    attestation,
  }: CctpTransactionsArgs
): Promise<CctpTransactionsResponse> => {
  const params = new URLSearchParams()
  if (amount) params.set('amount', amount)
  if (useForwarding !== undefined) params.set('useForwarding', String(useForwarding))
  if (transferType) params.set('transferType', transferType)
  if (recipientAddress) params.set('recipientAddress', recipientAddress)
  if (message) params.set('message', message)
  if (attestation) params.set('attestation', attestation)

  const response = await fetch(
    `${ctx.base}/cctp/transactions/${action}/${userAddress}/${srcNetwork}/${dstNetwork}?${params.toString()}`
  )

  if (!response.ok) {
    throw await parseCctpError(response, 'Failed to fetch CCTP transactions')
  }

  return response.json()
}
